import React, {FC, useEffect, useState} from "react";
import s from "./ModalUpdates.module.css";
import celebration from '../../../../assets/img/celebration.svg'
import character from '../../../../assets/img/character6.svg'
import cloud from '../../../../assets/img/cloud.svg'
const ModalUpdates: FC = () => {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const isSeeUpdates = localStorage.getItem("isSeeUpdates");
        if (!isSeeUpdates) {
            setIsOpen(true);
        }
    }, []);

    const closeModal = () => {
        setIsOpen(false);
        localStorage.setItem("isSeeUpdates", "true");
    };

    if (!isOpen) return null;

    return (
        <div className={s.modal_overlay}>
            <div className={s.modal_content}>
                <button className={s.modal_close} onClick={closeModal}>
                    &times;
                </button>
                <div className={s.modal_header}>
                    <h2>Latest Development <br/> Updates:</h2>
                </div>
                <div className={s.modal_body}>
                    <ul>
                        <li>-Introducing Simplee 1.2 content workflow automation</li>
                        <li>-Updated loading screen time</li>
                        <li>-Optimized AI prompt for more accurate output</li>
                        <li>-Improved content output format</li>
                        <li>-Enabled PDF export</li>
                        <li>-Optimized AI image generation</li>
                        <li>-Basic image resizing and effects</li>
                    </ul>
                    <p>Work-In-Progress:</p>
                    <ul>
                        <li>-Integration with social media channels to post directly</li>
                        <li>-Improvements on Image AI generation</li>
                        <li>-Fine-tuning text generation for more dynamic output</li>
                        <li>-Improvements on new effects and image editing features</li>
                        <li>-Mobile version optimization</li>
                    </ul>
                    <p className={s.beta_version}>BETA Version 1.2</p>

                </div>
                <div className={s.modal_footer}>
                    <button className={s.modal_button} onClick={closeModal}>
                        You Got It!
                    </button>
                </div>
                <img className={s.cloud} src={cloud}></img>
                <img src={character} className={s.character}/>
                <div className={s.welcome_text}>
                    <h3>Welcome to Simplee!</h3>
                    <p>Your creative content creation companion!</p>

                </div>
            </div>
        </div>
    );
};

export default ModalUpdates;
